import { ReactNode } from 'react';
import {
  PositionsStoreProvider,
  PositionsViewProvider,
} from '#/positions/contexts/store';
import { PositionsWebsocketProvider } from '#/positions/contexts/websocket';
import { PositionsSubscriptionProvider } from '#/positions/contexts/subscriber';
import PositionsFetcherProvider from '#/positions/contexts/fetcher';
import PositionFiltersProvider from '#/positions/contexts/filters/store';
import PositionGroupsProvider from '#/positions/contexts/position-groups';
import { SelectedPositionRowsProvider } from '#/positions/contexts/selected-positions';

interface Props {
  children: ReactNode;
}

export default function PositionsProviders({ children }: Props) {
  return (
    <PositionsWebsocketProvider>
      <PositionsSubscriptionProvider>
        <SelectedPositionRowsProvider>
          <PositionGroupsProvider>
            <PositionsStoreProvider>
              <PositionFiltersProvider>
                <PositionsFetcherProvider>
                  <PositionsViewProvider>{children}</PositionsViewProvider>
                </PositionsFetcherProvider>
              </PositionFiltersProvider>
            </PositionsStoreProvider>
          </PositionGroupsProvider>
        </SelectedPositionRowsProvider>
      </PositionsSubscriptionProvider>
    </PositionsWebsocketProvider>
  );
}
